import { CopyDirective } from '../shared/directives/copy.directive';
import { ChangeValuePipe } from '@shared/pipes/change-value.pipe';
import { PricePipe } from '@shared/pipes/price.pipe';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GbxsoftFormModule } from '@form/src/public-api';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuthFilePipe } from '@shared/pipes/authFile.pipe';
import { ModalTitleComponent } from '@shared/components/modal-title/modal-title.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { DragDropDirective } from '@shared/components/text-attachments-input/directives/drag-drop.directive';
import { CustomConfirmationPopoverDirective } from '@shared/libs/angular-confirmation-directive/custom-confirmation-popover.directive';
import { FilePreviewDirective } from '@shared/directives/file-preview.directive';
import { FilePreviewerComponent } from '@shared/components/file-previewer/file-previewer.component';
import { DateTimeFormatPipe } from '@shared/pipes/dateTimeFormat.pipe';
import { DateFormatPipe } from '@shared/pipes/dateFormat.pipe';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { UIModule } from '@shared/modules/ui/ui.module';
import { NgSelectExtendedModule } from '@shared/modules/ng-select-extended/ng-select-extended.module';
import { TextAttachmentsInputComponent } from '@shared/components/text-attachments-input/text-attachments-input.component';
import { RangeFormatPipe } from '@shared/pipes/rangeFormat.pipe';
import { NgSelectExtensionDirective } from '@shared/directives/ng-select-extension.directive';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PriceFormatPipe } from '@shared/pipes/price-format.pipe';
import { RangeFormatV2Pipe } from '@shared/pipes/range-format-v2.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';

const CORE_DIRECTIVES = [
  NgSelectExtensionDirective,
  DragDropDirective,
  CustomConfirmationPopoverDirective,
  FilePreviewDirective,
  CopyDirective
];

const CORE_PIPES = [
  AuthFilePipe,
  DateTimeFormatPipe,
  DateFormatPipe,
  RangeFormatPipe,
  RangeFormatV2Pipe,
  PricePipe,
  PriceFormatPipe,
  ChangeValuePipe
];
const CORE_COMPONENTS = [TextAttachmentsInputComponent, ModalTitleComponent, FilePreviewerComponent];

const CORE_MODULES = [
  CommonModule,
  NgSelectExtendedModule,
  MatTooltipModule,
  TranslateModule,
  UIModule,
  AngularSvgIconModule,
  FormsModule,
  ReactiveFormsModule,
  GbxsoftFormModule,
  MatMenuModule,
  MatDialogModule,
  NgxDaterangepickerMd.forRoot()
];

@NgModule({
  declarations: [CORE_DIRECTIVES, CORE_PIPES, CORE_COMPONENTS],
  exports: [NgSelectModule, CORE_MODULES, CORE_COMPONENTS, CORE_PIPES, CORE_DIRECTIVES],
  imports: [CORE_MODULES, NgxExtendedPdfViewerModule],
  providers: [CORE_PIPES],
  bootstrap: []
})
export class CoreModule {}
